import { useRef, useState } from 'react'

import { ControlledMenu, MenuItem, useClick } from '@szhsin/react-menu'
import styled from 'styled-components'

import { Box } from '../'

import { Color } from '@/utils'

import '@szhsin/react-menu/dist/index.css'

const StyledControlledMenu = styled(ControlledMenu)`
  ul {
      border-radius: ${({ $borderRadius }) => `${$borderRadius}px`};
`

const StyledMenuItem = styled(MenuItem)`
  &.szh-menu__item {
    color: ${({ color }) => color};
  }
  &.szh-menu__item--hover {
    background: ${() => Color.lightGrayHover};
    color: ${({ color }) => (color ? color : Color.primary)};
  }
`

const Dropdown = ({ children, onClick, options, borderRadius = 8 }) => {
    const ref = useRef(null)
    const [isOpen, setOpen] = useState(false)
    const anchorProps = useClick(isOpen, setOpen)

    return (
        <>
            <Box ref={ref} {...anchorProps}>
                {children}
            </Box>

            <StyledControlledMenu
                $borderRadius={borderRadius}
                state={isOpen ? 'open' : 'closed'}
                anchorRef={ref}
                onClose={() => setOpen(false)}
            >
                {options.map(option => (
                    <StyledMenuItem
                        onClick={() => onClick(option)}
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                        // @ts-ignore
                        color={option.color}
                    >
                        {option.label}
                    </StyledMenuItem>
                ))}
            </StyledControlledMenu>
        </>
    )
}

export { Dropdown }
